import React from 'react';
import { cx } from '@milanote/roma/utils';

import Icon from '../../../../../components/icons/Icon';
import Toast from '../../../../../structural/toast/Toast';
import ToastDismissButton from '../../../../../structural/toast/ToastDismissButton';
import type { ImageModalV2ErrorToastState } from './imageModalV2ErrorToastTypes';
import {
    IMAGE_MODAL_V2_TOAST_EXIT_FALLBACK_MS,
    IMAGE_MODAL_V2_TOAST_EXIT_HANDOFF_HOLD_MS,
} from '../imageModalV2Constants';
import { useImageModalV2SurfaceLifecycle } from './useImageModalV2SurfaceLifecycle';

import '../../../../../components/toast/ErrorToast.scss';
import './ImageModalV2ErrorToast.scss';

/** Modal-owned error toast whose enter/exit participates in the bottom-surface handoff. */
const ImageModalV2ErrorToast: React.FC<{
    toast: ImageModalV2ErrorToastState;
    isOpen: boolean;
    onExitComplete: () => void;
}> = ({ toast, isOpen, onExitComplete }) => {
    const { isShown, hasEntered, handleTransitionEnd } = useImageModalV2SurfaceLifecycle({
        isOpen,
        fallbackMs: IMAGE_MODAL_V2_TOAST_EXIT_FALLBACK_MS,
        exitHandoffMs: IMAGE_MODAL_V2_TOAST_EXIT_HANDOFF_HOLD_MS,
        onExitComplete,
    });

    return (
        <Toast
            className={cx('ErrorToast', 'ImageModalV2ErrorToast', isShown && 'is-shown', hasEntered && 'has-entered')}
            groupId="ImageModalV2"
            ownsMotion
            onTransitionEnd={handleTransitionEnd}
        >
            <Icon name="error-alert-round" />
            <span className="ErrorMessage">
                {toast.message}
                {toast.helpLink && (
                    <>
                        &nbsp;&nbsp;
                        <a
                            className="ErrorMessageLink"
                            href={toast.helpLink.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {toast.helpLink.label}
                        </a>
                    </>
                )}
            </span>
            <ToastDismissButton onClick={toast.onDismiss} />
        </Toast>
    );
};

export default ImageModalV2ErrorToast;
